import { shopVar } from "@/lib/shopStyles";
import type { GroupedProductDiscountLine } from "@/lib/TicketApi";
import { Money } from "@/lib/money";

/**
 * FAS-2031 — what the organiser takes off a bundle, one row each, under the parts it comes off.
 * The api sends the amount negative; the shop prints the magnitude behind a minus and never
 * works a discount out (the bundle price it shows is already the discounted one).
 */
export function GroupedDiscountLines({
    lines,
    lang,
    className,
}: {
    lines: GroupedProductDiscountLine[] | undefined;
    lang: string;
    className: string;
}) {
    if (!lines || lines.length === 0) return null;
    return (
        <>
            {lines.map((line, index) => (
                <li key={`discount-${line.name}-${index}`} data-testid="grouped-discount-line" className={className}>
                    <span style={{ color: shopVar("--shop-textColor") }}>{line.name}</span>
                    <span style={{ color: shopVar("--shop-textColor") }}>
                        −{Money.fromInteger(Math.abs(line.amount.amount), line.amount.currency).display(lang)}
                    </span>
                </li>
            ))}
        </>
    );
}
